import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-polygon-icon',
  templateUrl: './layout-layout-polygon.component.html'
})
export class LayoutLayoutPolygonComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
